import React, { useEffect, useState } from 'react';
import { Coins } from 'lucide-react';
import { getCurrencySymbol } from '../../lib/currency';

const KEY = 'deal_ccy_mode';

/** 'aud' = company currency; 'native' = each deal in its own price-book / estimate currency. Persisted in the browser. */
export function useCurrencyMode() {
  const [mode, setMode] = useState(() => (typeof window !== 'undefined' && window.localStorage.getItem(KEY)) || 'aud');
  useEffect(() => { window.localStorage.setItem(KEY, mode); }, [mode]);
  return [mode, setMode];
}

/** Format an AUD amount for a row: in native mode convert at the row's saved FX and use that currency's symbol. */
export const rowMoney = (mode, currency, fxToAud) => (v) => {
  if (v == null) return '—';
  if (mode !== 'native' || !currency || currency === 'AUD' || !fxToAud) return `A$${Math.round(v).toLocaleString()}`;
  return `${getCurrencySymbol(currency)}${Math.round(v / fxToAud).toLocaleString()}`;
};

export function CurrencyModeToggle({ mode, onChange, testId = 'ccy-mode-toggle' }) {
  const btn = (id, label, title) => (
    <button type="button" onClick={() => onChange(id)} title={title}
      className={`px-2 py-1 ${mode === id ? 'bg-[#0F2040] text-white' : 'text-slate-600 hover:bg-slate-50'} ${id === 'native' ? 'border-l border-slate-200' : ''}`} data-testid={`${testId}-${id}`}>{label}</button>
  );
  return (
    <div className="inline-flex items-center gap-1.5">
      <Coins className="w-3.5 h-3.5 text-slate-400" />
      <div className="inline-flex rounded-md border border-slate-200 overflow-hidden text-[11px]" role="group" aria-label="Currency display" data-testid={testId}>
        {btn('aud', 'A$ company', 'All amounts in AUD at the saved FX rates')}
        {btn('native', 'Deal currency', 'Each deal in its own price-book currency (implementation converted at the saved FX); totals and leaderboards stay in A$')}
      </div>
    </div>
  );
}
